import "../styles/Footer.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaLinkedinIn,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import grownexlogo from "../assets/grownex700.svg";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Top Section */}
        <div className="footer-top">

          <div className="footer-brand">
          <div className="footer-logo-wrapper">
            <Link to="/">
              <img
                src={grownexlogo}
                className="footer-logo"
                alt="Grownex Logo"
              />
            </Link>
          </div>
            <p>
              The next big thing starts here — drop us a line and let's
              get creating!
            </p>
          </div>

          <div className="footer-links">
          <ul className="footer-menu">
  <li><Link to="/">Home</Link></li>
  <li><Link to="/about">About Us</Link></li>
  <li><Link to="/work">Work</Link></li>
  <li>
    <HashLink smooth to="/#services">
      Services
    </HashLink>
  </li>
  <li><Link to="/insights">Insights</Link></li>
  <li><Link to="/contact">Contact</Link></li>
</ul>

            <ul className="footer-social-media-icons">
              <li>
                <FaLinkedinIn /> 
              </li>
              <li>
                <FaFacebookF /> 
              </li>
              <li>
                <FaInstagram /> 
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Row */}

        <div className="contact-row">

          <div className="contact-card">
            <FaPhoneAlt />
            <div>
              <h4>PHONE</h4>
              <p>+91 6281981832</p>
            </div>
          </div>

          <div className="contact-card">
            <FaEnvelope />
            <div>
              <h4>EMAIL</h4>
              <p>hello@grownex.in</p>
            </div>
          </div>

         <a
  href="https://maps.app.goo.gl/VNRxBVcLSKZYhMbw8"
  target="_blank"
  rel="noopener noreferrer"
  className="contact-card-link"
>
  <div className="contact-card">
    <FaMapMarkerAlt className="map" size={45} />
    <div>
      <h4>ADDRESS</h4>
      <p>
        4th Floor, Workflo - Oyo, Bziness Sphere, Jubilee Enclave,
        Madhapur, Hyderabad, Telangana 500081
      </p>
    </div>
  </div>
</a>

          <div className="contact-card">
            <FaClock />
            <div>
              <h4>OPENING HOURS</h4>
              <p>Mon to Sat: 9:00am - 7:00pm</p>
            </div>
          </div>

        </div>

        {/* Bottom */}

        <div className="footer-bottom">
          <p>© 2026 Grownex. All rights reserved.</p>

          <p>Built with purpose & precision</p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;